import React from 'react'
import { connect } from 'react-redux'
import { IndexLink } from 'react-router'
import FontIcon from 'material-ui/FontIcon'
import { updateCartItemsQty } from '../../store/cartItems'
import { loginFormVisible } from '../../store/login'

class CartIcon extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      cartItemsQty: this.props.cartItemsQty,
      isLogged: this.props.isLogged
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
        isLogged: nextProps.isLogged,
        cartItemsQty: nextProps.cartItemsQty
    });
  }

  openLoginForm = (e) => {
    if (!this.state.isLogged) {
      e.preventDefault()
      this.props.loginWindow(true)
    }
  }

  componentWillMount = () => {
    if (this.state.isLogged) {
      this.props.updateCartItemsQty()
    }
  }

  render = () => {
    const state = this.state;
    let number = '';
    if (state.isLogged) {
      number = <span className="product-number">{state.isLogged ? state.cartItemsQty : ''}</span>
    }

    return (
      <IndexLink className={'page-layout__nav-item--active cart-icon_wrapper'} to='/cart' onClick={this.openLoginForm}
      >
        <FontIcon
          className={'shopping-cart-icon menu-item'}
          style={{ color: '#FFFFFF', fontSize: '42px' }}
        >
          <span className={'icon-cart'}>

          </span>
        </FontIcon>
          {state.cartItemsQty ? number : ''}
      </IndexLink>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    cartItemsQty: state.cartItemsQty,
    isLogged: !!state.token
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginWindow: (value) => dispatch(loginFormVisible(value)),
    updateCartItemsQty: () => dispatch(updateCartItemsQty())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartIcon)



// WEBPACK FOOTER //
// ./src/components/cart/CartIcon.js